// extracted by mini-css-extract-plugin
export default {"toggleContainer":"g--z","toggleBtn":"h--z","toggleLabel":"i--z","tooltipContainer":"j--z","tooltipWrapper":"k--z","tooltipContentTop":"l--z"};